import { Component, OnInit,HostListener, Injector, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import moment from "moment";
import { ROLE_GESTOR_CONSULTA, ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { Tranche } from 'src/app/model/tranche.model';
import { LimitesFundo } from 'src/app/model/limite-agente-financeiro.model';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { LimiteService } from 'src/app/shared/services/limite.service';
import { LimiteAportado } from 'src/app/model/limite-aportado.model';
import { LimiteAporteService } from 'src/app/shared/services/limite-aporte.service';
import { BaseEntityComponent, BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ExportService } from 'src/app/features/habilitacao/export.service';
import { JanelaRenunciaResponseDto, Renuncia, TIPO_JANELA_RENUNCIA_COBERTURA_MAXIMA, TIPO_JANELA_RENUNCIA_LIMITE_ADICIONAL, TIPO_JANELA_VALIDACAO } from 'src/app/model/renuncia.model';
import { RenunciaService } from '../renuncia.service';
import { AgenteFinanceiroService } from 'src/app/shared/services/agente-financeiro.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { JanelaRenuncia } from 'src/app/model/janela-solicitacao-renuncia.model';
import { JanelaSolicitacaoRenunciaService } from '../janela-solicitacao-renuncia.service';
import { MensagemService } from '../../mensagem.service';
import { RenunciaLimiteAdicionalService } from '../renuncia-limite-adicional/renuncia-limite-adicional.service';
import { FileUtilsService } from 'src/app/shared/file-utils.service';
import { DatePipe } from '@angular/common';



@Component({
    selector: 'app-tarefas',
    templateUrl: 'tarefas.component.html',
    styleUrls: ['./tarefas.component.scss'],
    standalone: false
})
export class TarefasComponent extends BaseEntityComponent<JanelaRenuncia> implements OnInit {

    public formJanelaRenuncia: UntypedFormGroup;
    private janelaAtiva: JanelaRenuncia;
    private janelaLimiteAdicionalEncerrada: JanelaRenuncia;
    private agenteEnvio: boolean;
    public tipoJanela = TIPO_JANELA_VALIDACAO;
    private tipoJanelaApuracao: string;    
    dataHoje = new Date();
    dataHoraApuracao: Date;
    public janelaApurada: boolean = false;
    public janelaLimiteAdicionalApurada: boolean = false;
    private janelas: JanelaRenuncia[];
    private janelasAtivas: JanelaRenuncia[];
    private janelasLimiteAdicionalEncerradas: JanelaRenuncia[];
    public mensagemModal: string;
    @ViewChild('botoes') botoesPersonalizados: TemplateRef<any>;
    @ViewChild('body') msgPersonalizada: TemplateRef<any>;

    public readonly TIPO_JANELA_RENUNCIA_COBERTURA_MAXIMA = TIPO_JANELA_RENUNCIA_COBERTURA_MAXIMA;
    public readonly TIPO_JANELA_RENUNCIA_LIMITE_ADICIONAL = TIPO_JANELA_RENUNCIA_LIMITE_ADICIONAL;

    constructor(protected injector: Injector,
        private janelaSolicitacaoRenunciaService: JanelaSolicitacaoRenunciaService,
        private mensagemService: MensagemService,
        private permissaoService: PermissaoService,
        private modalService: BnModalMessageService,
        private renunciaService: RenunciaService,
        private renunciaLimiteAdicionalService: RenunciaLimiteAdicionalService,
        private fileUtils: FileUtilsService,        
        private datePipe: DatePipe,
        private loadingService: BnLoadingService) {
        super(janelaSolicitacaoRenunciaService);
    }

    public ngOnInit() {
        this.criarFormJanelaRenuncia();
        this.janelaSolicitacaoRenunciaService.obterJanelasAtivas().subscribe(janelasAtivas => {
            this.janelasAtivas = janelasAtivas;
        });

        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
            this.agenteEnvio = resp && resp[ROLE_GESTOR_ENVIO];
        });

        this.janelaSolicitacaoRenunciaService.findAll().subscribe(janelas => {
            this.janelas = janelas;            

            this.janelasLimiteAdicionalEncerradas = this.janelas.filter(j =>
                j.tipoJanela === TIPO_JANELA_RENUNCIA_LIMITE_ADICIONAL && this.isJanelaEncerrada(j));

            this.janelaLimiteAdicionalApurada = this.janelasLimiteAdicionalEncerradas.length > 0;

            if (this.janelas?.length > 0) {
                this.formJanelaRenuncia.get('dataInicioVigencia').disable();
                this.formJanelaRenuncia.get('dataFimVigencia').disable();
            }
        }); 

        this.renunciaService.getApuracaoRenunciasDetalhe().subscribe(apuracao => {
            if(apuracao) {
                this.janelaApurada = true;
                this.dataHoraApuracao = apuracao.dataHoraApuracao;
            }
        });
    }

    private atualizaForm(janela: JanelaRenuncia) {
        this.janelaAtiva = janela;
        if (janela != null) {
            this.formJanelaRenuncia.get('dataInicioVigencia').setValue(moment(janela.dataInicioVigencia));
            this.formJanelaRenuncia.get('dataFimVigencia').setValue(moment(janela.dataFimVigencia));
            this.formJanelaRenuncia.get('dataInicioVigencia').disable();
            this.formJanelaRenuncia.get('dataFimVigencia').disable();
        }
    }

    criarFormJanelaRenuncia() {
        this.formJanelaRenuncia = this.formBuilder.group({
            tipoJanela: [null, Validators.required],
            dataInicioVigencia: [null, Validators.required],
            dataFimVigencia: [null, Validators.required],
        });
    }

    cadastrar() {
        if (!this.formJanelaRenuncia.valid) {
            return;
        }

        let janela: JanelaRenuncia = this.formJanelaRenuncia.value;
        
        try {
            this.janelaSolicitacaoRenunciaService.salvar(janela).subscribe(janela => {
                this.atualizaForm(janela);
                this.mensagemService.adicionarMensagemSucesso('Janela de vigência para solicitação de renúncia criada com sucesso.');
            });
        } catch (error) {
            console.error('Erro ao salvar janela de vigência para solicitação de renúncia.', error);
            this.mensagemService.adicionarMensagemErro('Erro ao salvar janela de vigência para solicitação de renúncia.');
        }
    }

    podeCadastrar() {
        return !this.agenteEnvio || (this.janelaAtiva != null && !this.janelaAtiva.apurado) || this.existeJanelaAtivaParaTipoSelecionado();
    }

    limpar() {
        this.formJanelaRenuncia.get('dataInicioVigencia')?.reset();
        this.formJanelaRenuncia.get('dataFimVigencia')?.reset();
    }

    consultar() {
        let tipoSelecionado = this.formJanelaRenuncia.get('tipoJanela')?.value;

        this.router.navigate(['/renuncia/tarefas/janela-renuncia'], {
          state: {
            tipoJanela: tipoSelecionado
          }
        });
    }

    abrirModalConfirmarApuracao(tipoJanela: string) {
        this.tipoJanelaApuracao = tipoJanela;

        this.mensagemModal = tipoJanela === TIPO_JANELA_RENUNCIA_LIMITE_ADICIONAL
            ? 'Esta ação irá gerar e realizar o download do relatório de Apuração da Renúncia de Limite Adicional referente à janela selecionada.'
            : 'Esta ação irá realizar o fechamento da janela de Renúncia não permitindo sua edição.';

        this.modalService.abrir('Confirmação', undefined, 'md', this.msgPersonalizada, this.botoesPersonalizados);
    }

    dismissModal() {
        this.modalService.dismiss();
    }

    podeApurarRenuncias() {
        return this.agenteEnvio;
    }

    apurarRenuncia() {
        if (this.tipoJanelaApuracao === TIPO_JANELA_RENUNCIA_COBERTURA_MAXIMA) {
            this.apurarRenunciaCoberturaMaxima();
            return;
        }

        if (this.tipoJanelaApuracao === TIPO_JANELA_RENUNCIA_LIMITE_ADICIONAL) {
            this.apurarRenunciaLimiteAdicional();
            return;
        }    
    }

    apurarRenunciaCoberturaMaxima() {
        try {
            this.loadingService.bloqueiaTela();
            this.renunciaService.getApurarRenuncias().subscribe(apuracao => {
                this.mensagemService.adicionarMensagemSucesso('Execução submetida com sucesso. Relatório será enviado em instantes por e-mail.');
            });
            this.loadingService.liberaTela();
            this.dismissModal();
        } catch (error) {
            this.tratarErroApuracao(error);
        }
    }

    apurarRenunciaLimiteAdicional() {
        try {
            if (!this.janelaLimiteAdicionalEncerrada?.id) {
                this.mensagemService.adicionarMensagemErro('Nenhuma janela foi selecionada.');
                return;
            }
        
            this.loadingService.bloqueiaTela();

            this.renunciaLimiteAdicionalService.gerarRelatorioLimiteAdicional(this.janelaLimiteAdicionalEncerrada.id).subscribe(resp => {
                if (!resp || resp.length === 0) {
                    this.mensagemService.adicionarMensagemAviso('Não foram encontrados registros para a janela selecionada.');
                    this.loadingService.liberaTela();
                    this.dismissModal();
                    return;
                }

                let cabecalhoJanela = `Apuração Renuncia Limite Adicional - Janela vigência ${moment(this.janelaLimiteAdicionalEncerrada.dataInicioVigencia).format('DD/MM/YYYY')} - ${moment(this.janelaLimiteAdicionalEncerrada.dataFimVigencia).format('DD/MM/YYYY')}`;

                let cabecalho = 'CNPJ;Agente Financeiro;Data Solicitação;Usuário Solicitante;Redução Faixa;Renúncia Total;Renúncia Parcial R$;Percentual %';

                let conteudoCsv = cabecalhoJanela + '\n\n' + cabecalho;

                resp.forEach(item => {
                    conteudoCsv += '\n' +
                    `${item.cnpjAgenteFinanceiro + '\t'};` +
                    `${item.nomeAgenteFinanceiro};` +
                    this.formatarData(item.dataSolicitacao) + ';' +
                    `${item.usuarioResponsavel};` +
                    `${item.habilitacaoFaixaPj ? 'Sim' : 'Não'};` +
                    `${item.renunciaTotal ? 'Sim' : 'Não'};` +
                    this.formatarMoeda(item.valorParcial ?? '') + ';' +
                    this.formatarMoeda(item.percentualParcial ?? '');
                });

                this.fileUtils.exportarArquivo('apuracao-renuncia-limite-adicional.csv','\ufeff' + conteudoCsv, FileUtilsService.TEXT_CSV);

                this.mensagemService.adicionarMensagemSucesso('Relatório de Apuração da Renúncia de Limite Adicional solicitado com sucesso.');
                this.loadingService.liberaTela();
                this.dismissModal();
            });
        } catch (error) {
            this.tratarErroApuracao(error);
        }
    }

    private tratarErroApuracao(error: any) {
        console.error('Erro ao submeter apuração.', error);
        this.mensagemService.adicionarMensagemErro('Erro ao submeter apuração.');
        this.loadingService.liberaTela();
        this.dismissModal();
    }    

    selecionarTipoJanela() {
        let tipoJanela = this.formJanelaRenuncia.get('tipoJanela')?.value;

        this.janelaAtiva = null;

        this.formJanelaRenuncia.get('dataInicioVigencia')?.reset();
        this.formJanelaRenuncia.get('dataFimVigencia')?.reset();

        if (!tipoJanela) {
            return;
        }

        if (tipoJanela === TIPO_JANELA_RENUNCIA_COBERTURA_MAXIMA) {
            let janela = this.janelas?.find(j => j.tipoJanela === tipoJanela);

            if (janela) {
                this.atualizaForm(janela);
            }

            return;
        }

        if (tipoJanela === TIPO_JANELA_RENUNCIA_LIMITE_ADICIONAL) {
            let janelaAtiva = this.janelasAtivas?.find(j => j.tipoJanela === tipoJanela);

            if (janelaAtiva) {
                this.atualizaForm(janelaAtiva);
            } else {
                this.formJanelaRenuncia.get('dataInicioVigencia')?.enable();
                this.formJanelaRenuncia.get('dataFimVigencia')?.enable();
            }
        }
    }

    possuiTipoSelecionado(): boolean {
        let tipoJanela = this.formJanelaRenuncia.get('tipoJanela');
        return tipoJanela != null && tipoJanela.value != null && tipoJanela.value !== 'null';
    }

    existeJanelaAtivaParaTipoSelecionado(): boolean {
        let tipoSelecionado = this.formJanelaRenuncia.get('tipoJanela')?.value;

        if (!tipoSelecionado || !this.janelasAtivas) {
            return false;
        }

        return this.janelasAtivas.some(j => j.tipoJanela === tipoSelecionado);
    }

    isJanelaEncerrada(janela: JanelaRenuncia): boolean {
        return moment(janela.dataFimVigencia).isBefore(moment());
    }

    podeExecutarApuracaoLimiteAdicional(): boolean {
        return this.janelaLimiteAdicionalApurada && this.janelaLimiteAdicionalEncerrada != null;
    }

    formatarData(data, comHora?) {
        const hora = comHora ? 'HH:mm:ss' : '';
        return data ? this.datePipe.transform(data, 'dd/MM/yyyy ' + hora) : '';
    }

    formatarMoeda(moeda) {
        if (!isNaN(moeda)) {
            return Number(moeda).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        }
        return '';
    }
}
